export default __webpack_public_path__ + "static/media/project-marbletheory.5d4d1d0c.png";